module.exports = __webpack_public_path__ + "img/volunteers_hero_image.1639551.png";